import { parsePhoneNumber } from "libphonenumber-js";

export const parsePhone = parsePhoneNumber;

export const formatPhone = (phone: string) => {
  return parsePhone(phone, "FR").formatInternational();
};
